import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../../utils/supabaseClient";

export default function AdminEditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    loadProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function loadProduct() {
    const { data } = await supabase
      .from("products")
      .select("*")
      .eq("id", id)
      .single();

    setProduct(data);
  }

  async function handleUpdate() {
    setMessage("");

    let image_url = product.image_url;

    // Upload new image if selected
    if (image) {
      const fileName = `${Date.now()}-${image.name}`;

      await supabase.storage.from("product-images").upload(fileName, image);

      image_url = supabase.storage
        .from("product-images")
        .getPublicUrl(fileName).data.publicUrl;
    }

    // Update DB
    const { error } = await supabase
      .from("products")
      .update({
        name: product.name,
        description: product.description,
        price: product.price,
        category: product.category,
        image_url,
        stock: product.stock,
        low_stock_threshold: product.low_stock_threshold,
      })
      .eq("id", id);

    if (!error) {
      setMessage("Product updated!");
      setTimeout(() => navigate("/admin/products"), 800);
    }
  }

  if (!product) return <p>Loading...</p>;

  return (
    <div className="page admin-edit-product">
      <h2>Edit Product</h2>

      {message && <p>{message}</p>}

      <input
        type="text"
        value={product.name}
        onChange={(e) => setProduct({ ...product, name: e.target.value })}
      />

      <textarea
        value={product.description}
        onChange={(e) =>
          setProduct({ ...product, description: e.target.value })
        }
      />

      <input
        type="number"
        value={product.price}
        onChange={(e) =>
          setProduct({ ...product, price: Number(e.target.value) })
        }
      />

      <select
        value={product.category}
        onChange={(e) =>
          setProduct({ ...product, category: e.target.value })
        }
      >
        <option value="grains">Grains</option>
        <option value="legumes">Legumes</option>
        <option value="spices">Spices</option>
      </select>

      <input 
        type="file" 
        onChange={(e) => 
            setImage(e.target.files[0])
        } 
      />

      <input
        type="number"
        value={product.stock}
        onChange={(e) =>
            setProduct({ ...product, stock: Number(e.target.value) })
        }
      />

      <button onClick={handleUpdate}>Save Changes</button>
    </div>
  );
}